import { WbEditor, WbTabPanel } from '@agilelab/plugin-wb-platform';
import { Box, makeStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { FC, useEffect, useState } from 'react';
import { useEditorPageContext } from '../context/useEditorPageContext';
import { DescriptorCustomViewCard } from './DescriptorCustomViewCard';

const useStyles = makeStyles(
  {
    tabPanel: {
      display: 'flex',
      flex: 1,
      minHeight: 0,
      overflow: 'hidden',
      flexDirection: 'column',
    },
  },
  { name: 'DescriptorCard' },
);

export const DescriptorCard: FC = () => {
  const classes = useStyles();
  const { descriptorState, descriptorStateWithComponents, setMonacoEditorRef } =
    useEditorPageContext();

  const isLoading =
    descriptorState.loading || descriptorState.value === undefined;

  const [loadingText, setLoadingText] = useState('# Loading components');

  useEffect(() => {
    if (descriptorStateWithComponents.loading) {
      let count = 0;
      const loadingCharacters = ['|', '/', '-', '\\'];
      const interval = setInterval(() => {
        count = (count % loadingCharacters.length) + 1;

        setLoadingText(`# Loading components ${loadingCharacters[count - 1]}`);
      }, 300);

      return () => clearInterval(interval);
    }

    return () => {};
  }, [descriptorStateWithComponents.loading]);

  return (
    <Box height="100%" display="flex" flexDirection="column" padding={1.5}>
      {isLoading && (
        <Box style={{ width: '100%' }}>
          <Skeleton variant="text" height="3vh" width="15%" />
          <Skeleton variant="text" height="3vh" width="19%" />
          <Skeleton variant="text" height="3vh" width="25%" />
          <Skeleton variant="text" height="3vh" width="20%" />
          <Skeleton variant="text" height="3vh" width="37%" />
          <Skeleton variant="text" height="3vh" width="20%" />
          <Skeleton variant="text" height="3vh" width="32%" />
          <Skeleton variant="text" height="3vh" width="26%" />
          <Skeleton variant="text" height="3vh" width="20%" />
          <Skeleton variant="text" height="3vh" width="32%" />
          <Skeleton variant="text" height="3vh" width="12%" />
          <Skeleton variant="text" height="3vh" width="52%" />
          <Skeleton variant="text" height="3vh" width="37%" />
          <Skeleton variant="text" height="3vh" width="20%" />
          <Skeleton variant="text" height="3vh" width="32%" />
          <Skeleton variant="text" height="3vh" width="26%" />
          <Skeleton variant="text" height="3vh" width="20%" />
          <Skeleton variant="text" height="3vh" width="37%" />
          <Skeleton variant="text" height="3vh" width="12%" />
          <Skeleton variant="text" height="3vh" width="52%" />
        </Box>
      )}

      {!isLoading && (
        <WbTabPanel value="customView" className={classes.tabPanel}>
          <DescriptorCustomViewCard />
        </WbTabPanel>
      )}

      {!isLoading && (
        <WbTabPanel value="yaml" className={classes.tabPanel} keepMounted>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flex={1}
            minHeight={0}
            overflow="hidden"
          >
            <WbEditor
              theme="white"
              value={
                descriptorStateWithComponents.loading
                  ? descriptorState?.value?.replace(
                      'components: []',
                      loadingText,
                    )
                  : descriptorStateWithComponents.value || ''
              }
              options={{ readOnly: true }}
              onMount={setMonacoEditorRef}
            />
          </Box>
        </WbTabPanel>
      )}
    </Box>
  );
};
